import React, { type PropsWithChildren, forwardRef } from 'react';
import classNames from 'classnames';

interface DropdownMenuProps {
  /**
   * Custom element to use as the dropdown trigger.
   */
  customTrigger?: React.ReactElement;

  /**
   * Label text for the default button trigger.
   */
  triggerText?: React.ReactNode;

  icon?: string;
  style?: React.CSSProperties;
  className?: string;
}

export const DropdownMenu = forwardRef<
  HTMLDivElement,
  PropsWithChildren<DropdownMenuProps>
>(
  (
    {
      children,
      icon = 'fa-solid fa-caret-down',
      customTrigger,
      triggerText,
      style,
    },
    ref
  ) => {
    let trigger;

    if (customTrigger) {
      trigger = customTrigger;
    } else {
      trigger = (
        <button type='button' className='popdown__trigger btn btn-ghost'>
          {triggerText}
          <i className={icon} />
        </button>
      );
    }

    return (
      <div ref={ref} className='popdown' style={style}>
        <div className='popdown__trigger'>{trigger}</div>
        <div className='popdown__menu' x-placement='bottom-start'>
          {children}
        </div>
      </div>
    );
  }
);

export const DropdownMenuSection = ({ children }) => <ul>{children}</ul>;

interface DropdownMenuItemProps {
  /**
   * Handler invoked when the menu item is clicked.
   */
  onClick?: () => void;
  active?: boolean;
  href?: string;
  className?: string;
  linkClassName?: string;
  disabled?: boolean;
}

export const DropdownMenuItem: React.FC<
  PropsWithChildren<DropdownMenuItemProps>
> = ({
  active = false,
  href = '#',
  onClick,
  children,
  linkClassName,
  ...props
}) => (
  <li>
    <a
      href={href}
      onClick={onClick}
      className={classNames({ active }, linkClassName)}
      {...props}
    >
      {children}
    </a>
  </li>
);
